/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import Videos from "components/widgets/introVideos/Videos";
import {Trans} from "react-i18next";

class IntroductionVideosContainer extends Component {
  render() {
    return (
      <section className="sssArea my-3">
        <div className="container">
          {/* <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="#">
                    <span className="icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#">Kurumsal</a>
                </li>
                <li className="active">Tanıtım Videoları</li>
              </ul>
            </div>
          </div> */}
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="sssBaslik"><Trans desc="Tanıtım Videoları">10023</Trans></div>
            </div>
          </div>
          <Videos />
        </div>
      </section>
    );
  }
}

export default IntroductionVideosContainer;
